// extracted by mini-css-extract-plugin
export default {"mediumDesktop":"(max-width: 1180px)","overlayApplicationProWrapper":"OverlayApplicationPro_overlayApplicationProWrapper__wAnjb"};